var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        { attrs: { inline: true, model: _vm.filters } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "关键词" } },
            [
              _c("el-input", {
                attrs: { size: "small", placeholder: "关键字" },
                model: {
                  value: _vm.filters.search,
                  callback: function($$v) {
                    _vm.$set(_vm.filters, "search", $$v)
                  },
                  expression: "filters.search"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.queryAll }
                },
                [_vm._v("查询")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "success" },
                  on: { click: _vm.handleCreate }
                },
                [_vm._v("添加")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          attrs: {
            size: "mini",
            stripe: "",
            border: "",
            data: _vm.tableData,
            "highlight-current-row": "",
            "expand-on-click-node": "false"
          }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "Name", label: "奖品名称", "min-width": "120" }
          }),
          _c("el-table-column", {
            attrs: { prop: "Price", label: "奖品价值", width: "100" }
          }),
          _c("el-table-column", {
            attrs: { prop: "Count", label: "发行数量", width: "100" }
          }),
          _c("el-table-column", {
            attrs: { prop: "BeginDate", label: "有效起期", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.format.dateFormat(scope.row.BeginDate)) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "EndDate", label: "有效止期", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.format.dateFormat(scope.row.EndDate)) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "Logo", label: "图片", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.Logo
                      ? _c("viewer", [
                          scope.row.Logo
                            ? _c("img", {
                                key: scope.row.Logo,
                                staticStyle: { height: "40px" },
                                attrs: { src: _vm.baseUrl + scope.row.Logo }
                              })
                            : _vm._e()
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "Description",
              label: "兑奖说明",
              "min-width": "120"
            }
          }),
          _c("el-table-column", {
            attrs: {
              sortable: "",
              prop: "InsertTime",
              label: "创建时间",
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.format.dateTimeFormat(scope.row.InsertTime)
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.handleUpdate(scope.row)
                          }
                        }
                      },
                      [_vm._v("修改")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.handleDelete(scope.row)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "page-sizes": _vm.pageSizesList,
              "page-size": _vm.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
              "current-page": _vm.pageIndex
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
              "update:currentPage": function($event) {
                _vm.pageIndex = $event
              },
              "update:current-page": function($event) {
                _vm.pageIndex = $event
              }
            }
          })
        ],
        1
      ),
      _c("awardEditor", { ref: "awardEditor", on: { update: _vm.queryAll } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }